import { Link } from "react-router-dom";
import { fadeInUp } from "./Animations.styles";
import styled from "styled-components";

export const TotalsSection = styled.div`
    background: rgba(255, 255, 255, 0.95);
    padding: 12px;
    border-radius: 8px;
    border: none;
    margin-bottom: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.2s;
    animation: ${fadeInUp} 0.7s ease-out;

    &:hover {
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    }
`;

export const TotalsInner = styled.div`
    background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
    border-radius: 8px;
    padding: 8px;
    border: 1px solid rgba(209, 213, 219, 0.6);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const TotalsGrid = styled.div`
    display: flex;
    gap: 6px;
    margin-bottom: 8px;
`;

export const TotalBox = styled.div`
    flex: 1;
    background: rgba(255, 255, 255, 0.9);
    padding: 6px 8px;
    border-radius: 6px;
    border: 1px solid rgba(209, 213, 219, 0.6);
    text-align: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        border-color: #9ca3af;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
`;

export const TotalLabel = styled.div`
    font-size: 8px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
`;

export const TotalValue = styled.div`
    font-size: 14px;
    font-weight: 700;
    color: #1f2937;
`;

export const InternalLink = styled(Link)`
    display: block;
    font-size: 11px;
    font-weight: 600;
    color: #4b5563;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.2s;
    margin-top: 6px;

    &:link,
    &:visited,
    &:hover,
    &:active,
    &:focus {
        text-decoration: none;
    }

    &:hover {
        color: #1f2937;
    }
`;

export const ProgressBarContainer = styled.div`
    width: 100%;
    height: 5px;
    background: rgba(209, 213, 219, 0.5);
    border-radius: 2px;
    overflow: hidden;
    margin-bottom: 6px;
`;

export const ProgressBarFill = styled.div`
    height: 100%;
    background: linear-gradient(90deg, #d1d5db 0%, #9ca3af 100%);
    border-radius: 2px;
    transition: width 0.5s ease-out;
    width: ${(props) => props.percentage}%;
`;
